export const listaExamesDisponiveis = [
  { "categoria": "BIOQUÍMICA", "nome": "Albumina" },
  { "categoria": "BIOQUÍMICA", "nome": "Amilase" },
  { "categoria": "BIOQUÍMICA", "nome": "Alanina aminotransferase (ALT)" },
  { "categoria": "BIOQUÍMICA", "nome": "Bilirrubina total" },
  { "categoria": "BIOQUÍMICA", "nome": "Bilirrubina direta (conjugada)" },
  { "categoria": "BIOQUÍMICA", "nome": "Cálcio" },
  { "categoria": "BIOQUÍMICA", "nome": "Colesterol" },
  { "categoria": "BIOQUÍMICA", "nome": "Creatinina" },
  { "categoria": "BIOQUÍMICA", "nome": "Ferro" },
  { "categoria": "BIOQUÍMICA", "nome": "Fosfatase alcalina (FA)" },
  { "categoria": "BIOQUÍMICA", "nome": "Fósforo" },
  { "categoria": "BIOQUÍMICA", "nome": "Frutosamina" },
  { "categoria": "BIOQUÍMICA", "nome": "Gama-glutamil transferase (GGT)" },
  { "categoria": "BIOQUÍMICA", "nome": "Glicose" },
  { "categoria": "BIOQUÍMICA", "nome": "Globulina" },
  { "categoria": "BIOQUÍMICA", "nome": "Lipase" },
  { "categoria": "BIOQUÍMICA", "nome": "Proteínas séricas totais" },
  { "categoria": "BIOQUÍMICA", "nome": "SDMA (IDEXX)" },
  { "categoria": "BIOQUÍMICA", "nome": "Triglicerídeos" },
  { "categoria": "BIOQUÍMICA", "nome": "Ureia" },
  { "categoria": "URINA/FEZES", "nome": "Exame qualitativo de urina" },
  { "categoria": "URINA/FEZES", "nome": "Exame parasitológico de fezes (Coproplus)" },
  { "categoria": "URINA/FEZES", "nome": "Razão proteína/creatinina na urina" },
  { "categoria": "URINA/FEZES", "nome": "Razão GGT/creatinina na urina" },
  { "categoria": "HEMOSTASIA", "nome": "Tempo de Protrombina (TP)" },
  { "categoria": "HEMOSTASIA", "nome": "Tempo de Tromboplastina Parcial ativada (TTPa)" },
  { "categoria": "HEMATOLOGIA", "nome": "Hemograma (com plaquetas e prot. Plasm. Total) – Mamíferos" },
  { "categoria": "HEMATOLOGIA", "nome": "Hemograma (com pesquisa de Hemocitozoários)" },
  { "categoria": "HEMATOLOGIA", "nome": "Hemograma + Fibrinogênio – Equinos" },
  { "categoria": "HEMATOLOGIA", "nome": "Contagem corrigida de reticulócitos" },
  { "categoria": "HEMATOLOGIA", "nome": "Teste de compatibilidade (doador + receptor)" },
  { "categoria": "HORMÔNIOS", "nome": "Cortisol pós Dexa (2 dosagens – basal + 8h após)" },
  { "categoria": "HORMÔNIOS", "nome": "Cortisol pós Dexa (3 dosagens – basal + 4h + 8h após)" },
  { "categoria": "HORMÔNIOS", "nome": "Cortisol pós ACTH (2 dosagens – basal + após ACTH)" },
  { "categoria": "HORMÔNIOS", "nome": "Insulina" },
  { "categoria": "HORMÔNIOS", "nome": "17 – OH Progesterona" },
  { "categoria": "HORMÔNIOS", "nome": "T4 total + T4 livre por diálise + TSH (CL)" },
  { "categoria": "HORMÔNIOS", "nome": "T4 total IDEXX" },
  { "categoria": "PERFIS", "nome": "Combo 1 – Hemograma, ALT, CREAT" },
  { "categoria": "PERFIS", "nome": "Combo 2 – Hemograma, ALT, CREAT, FA, Ureia" },
  { "categoria": "PERFIS", "nome": "Combo 3 – Hemograma, ALB, ALT, CREAT" },
  { "categoria": "PERFIS", "nome": "Combo 4 – Hemograma, ALB, ALT, CREAT, FA, Ureia" },
  { "categoria": "PERFIS", "nome": "Combo 5 – Hemograma, ALB, ALT, CREAT, FA, Ureia, COL, TRIG" },
  { "categoria": "PERFIS", "nome": "Combo 6 – Hemograma, ALB, ALT, FA, GGT, Ureia, Bilirrubinas" },
  { "categoria": "PERFIS", "nome": "Combo 7 – Eletrólitos CL, Na, K, Na/K" },
  { "categoria": "PERFIS", "nome": "Pós-hemodiálise – Hemograma, CREAT, Ureia" },
  { "categoria": "SOROLOGIA", "nome": "Cinomose (antígeno) ALERE" },
  { "categoria": "SOROLOGIA", "nome": "4DX (Dirofilariose, Lyme, Ehrlichia, Anaplasma)" },
  { "categoria": "SOROLOGIA", "nome": "Leishmaniose ALERE/IDEXX" },
  { "categoria": "SOROLOGIA", "nome": "Lipase pancreática específica (cPL/fPL)" },
  { "categoria": "SOROLOGIA", "nome": "Parvovirose/Coronavirose ALERE" },
  { "categoria": "SOROLOGIA", "nome": "Vírus da Imunodeficiência (FIV) / Leucemia Felina (FeLV)" },
  { "categoria": "IMAGEM - RADIOGRAFIA", "nome": "Raio-X Torácica" },
  { "categoria": "IMAGEM - RADIOGRAFIA", "nome": "Raio-X Abdominal" },
  { "categoria": "IMAGEM - RADIOGRAFIA", "nome": "Raio-X Ortopédica" },
  { "categoria": "IMAGEM - RADIOGRAFIA", "nome": "Raio-X Boca/Dentária" },
  { "categoria": "IMAGEM - ULTRASSOM", "nome": "Ultrassonografia Abdominal" },
  { "categoria": "IMAGEM - ULTRASSOM", "nome": "Ecocardiograma" },
  { "categoria": "IMAGEM - ULTRASSOM", "nome": "Doppler Vascular" },
  { "categoria": "IMAGEM - ULTRASSOM", "nome": "Ultrassom Ocular" },
  { "categoria": "ALTA RESOLUÇÃO", "nome": "Tomografia Computadorizada" },
  { "categoria": "ALTA RESOLUÇÃO", "nome": "Ressonância Magnética" },
  { "categoria": "ENDOSCOPIA", "nome": "Gastroscopia/Colonoscopia" },
  { "categoria": "ENDOSCOPIA", "nome": "Rinoscopia/Otoscopia" },
  { "categoria": "EXAMES COM CONTRASTE", "nome": "Estudo com Bário" },
  { "categoria": "EXAMES COM CONTRASTE", "nome": "Cistografia/Mielografia" },
  { "categoria": "OUTROS", "nome": "Outros exames (descrever na prescrição)" }
];